var _excluded = ["invert", "size"];

var _templateObject, _templateObject2;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import styled from "styled-components";
import { nanoid } from "nanoid";
import { colorDarkest, colorWhite } from "@nib-components/theme";
import { sizePropType } from "../../utils";
export var DividingLine = styled.line(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fill: none;\n  stroke: ", ";\n  stroke-miterlimit: 10;\n  stroke-width: 0.5px;\n"])), function (props) {
  return props.invert ? colorWhite : colorDarkest;
});
export var WordMarkPath = styled.path(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  fill: ", ";\n"])), function (props) {
  return props.invert ? colorWhite : colorDarkest;
}); // small === min-height from brand guidelines

var sizes = {
  small: {
    width: "117px",
    height: "24px"
  },
  header: {
    width: "175px",
    height: "36px"
  },
  medium: {
    width: "233px",
    height: "48px"
  },
  large: {
    width: "310px",
    height: "64px"
  }
};

var QantasLogo = function QantasLogo(props) {
  var invert = props.invert,
      _props$size = props.size,
      size = _props$size === void 0 ? "small" : _props$size,
      otherProps = _objectWithoutProperties(props, _excluded); // Because this logo uses gradients, ids are unavoidable.


  var _React$useState = React.useState(nanoid(10)),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      uniqueId1 = _React$useState2[0];

  var _React$useState3 = React.useState(nanoid(10)),
      _React$useState4 = _slicedToArray(_React$useState3, 1),
      uniqueId2 = _React$useState4[0];

  var _React$useState5 = React.useState(nanoid(10)),
      _React$useState6 = _slicedToArray(_React$useState5, 1),
      uniqueId3 = _React$useState6[0];

  var _React$useState7 = React.useState(nanoid(10)),
      _React$useState8 = _slicedToArray(_React$useState7, 1),
      uniqueId4 = _React$useState8[0];

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 165.1 34.1",
    width: sizes[size].width,
    height: sizes[size].height
  }, otherProps), /*#__PURE__*/React.createElement("linearGradient", {
    id: uniqueId1,
    gradientUnits: "userSpaceOnUse",
    x1: "30.0285",
    y1: "0.4788",
    x2: "6.9785",
    y2: "34.1388",
    gradientTransform: "matrix(1 0 0 -1 0 34.2396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#BE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.39",
    stopColor: "#DE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.77",
    stopColor: "#F60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: uniqueId2,
    gradientUnits: "userSpaceOnUse",
    x1: "23.6592",
    y1: "15.6799",
    x2: "23.9693",
    y2: "19.2313",
    gradientTransform: "matrix(1 0 0 -1 0 34.2396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.65",
    stopColor: "#FFFFFF",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.69",
    stopColor: "#EDEDED",
    stopOpacity: "0.23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.76",
    stopColor: "#D7D7D7",
    stopOpacity: "0.5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.81",
    stopColor: "#C6C6C6",
    stopOpacity: "0.72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.87",
    stopColor: "#B9B9B9",
    stopOpacity: "0.87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.91",
    stopColor: "#B2B2B2",
    stopOpacity: "0.97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.95",
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: uniqueId3,
    gradientUnits: "userSpaceOnUse",
    x1: "19.1",
    y1: "6.3084",
    x2: "34.04",
    y2: "6.3084",
    gradientTransform: "matrix(1 0 0 -1 0 34.2396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#FFFFFF",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "7.000000e-02",
    stopColor: "#F3F3F3",
    stopOpacity: "0.15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.21",
    stopColor: "#DEDEDE",
    stopOpacity: "0.41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.35",
    stopColor: "#CDCDCD",
    stopOpacity: "0.62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.49",
    stopColor: "#C0C0C0",
    stopOpacity: "0.79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.63",
    stopColor: "#B7B7B7",
    stopOpacity: "0.91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.77",
    stopColor: "#B1B1B1",
    stopOpacity: "0.98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.9",
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: uniqueId4,
    gradientUnits: "userSpaceOnUse",
    x1: "0.43",
    y1: "21.8198",
    x2: "17.14",
    y2: "21.8198",
    gradientTransform: "matrix(1 0 0 -1 0 34.2396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.25",
    stopColor: "#FFFFFF",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.36",
    stopColor: "#F7F7F7",
    stopOpacity: "0.11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.58",
    stopColor: "#E1E1E1",
    stopOpacity: "0.38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.88",
    stopColor: "#BEBEBE",
    stopOpacity: "0.82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M80.3,9c0.1,1.4-0.6,2.8-1.8,3.6l1.8,2.8h-1.6L77.1,13c-0.2,0-0.4,0.1-0.6,0.1c-2.2,0-3.7-1.6-3.7-4.1V4.1 c0-2.5,1.5-4.1,3.7-4.1s3.8,1.6,3.8,4V9z M74.1,9c-0.1,1.3,0.8,2.5,2.1,2.7c1.3,0.1,2.5-0.8,2.7-2.1c0-0.2,0-0.4,0-0.5V4 c0.1-1.3-0.8-2.5-2.1-2.7c-1.3-0.1-2.5,0.8-2.7,2.1c0,0.2,0,0.4,0,0.5V9z"
  }), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M83.4,12.9L87,0.2h1.3L92,12.9h-1.4l-0.8-2.9h-4.3l-0.8,2.9H83.4z M85.9,8.7h3.7l-1.8-6.5L85.9,8.7z"
  }), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M102.9,12.9h-1.1l-4.9-9.7v9.8h-1.2V0.2h1.2l4.8,9.6V0.2h1.2V12.9z"
  }), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M106.4,0.2h7.3v1.3h-3v11.3h-1.3V1.5h-3L106.4,0.2z"
  }), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M115.3,12.9L119,0.2h1.3l3.7,12.7h-1.4l-0.8-2.9h-4.3l-0.8,2.9H115.3z M117.8,8.7h3.7l-1.9-6.5L117.8,8.7z"
  }), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M132.7,3.8V3.5c0.1-1.2-0.8-2.2-2-2.3c-0.1,0-0.2,0-0.2,0c-1.4,0-2.2,0.8-2.2,1.9c0,0.8,0.5,1.6,1.3,1.9 l1.9,0.9c1.3,0.6,2.8,1.3,2.8,3.5c0.1,1.9-1.4,3.6-3.3,3.7c-0.1,0-0.3,0-0.4,0c-1.9,0.2-3.5-1.2-3.7-3.1c0-0.1,0-0.3,0-0.4V9.2h1.3 v0.4c0,1.2,0.9,2.2,2.1,2.3c0.1,0,0.2,0,0.3,0c1.2,0.1,2.3-0.8,2.4-2c0-0.1,0-0.2,0-0.3c0-1.4-0.9-1.9-1.9-2.4l-1.6-0.7 C128,6,127,4.7,127,3.3c0-1.8,1.4-3.2,3.1-3.3c0.1,0,0.2,0,0.3,0c1.8-0.1,3.4,1.3,3.5,3.1c0,0.2,0,0.3,0,0.5v0.2H132.7z"
  }), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M74.4,33.9h-1.3V21.2h1.3V33.9z"
  }), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M86.3,33.9h-1.1l-4.9-9.7v9.8H79V21.2h1.2l4.8,9.6v-9.6h1.2L86.3,33.9z"
  }), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M95.9,24.8v-0.3c0.1-1.2-0.8-2.2-2-2.3c-0.1,0-0.2,0-0.2,0c-1.4,0-2.2,0.8-2.2,1.9c0,0.8,0.5,1.6,1.3,1.8 l1.9,0.8c1.3,0.6,2.8,1.3,2.8,3.5c0.1,1.9-1.4,3.6-3.3,3.7c-0.1,0-0.3,0-0.4,0c-1.9,0.2-3.5-1.2-3.7-3.1c0-0.1,0-0.3,0-0.4v-0.3h1.3 v0.4c0,1.2,0.9,2.2,2.1,2.3c0.1,0,0.2,0,0.3,0c1.2,0.1,2.3-0.8,2.4-2c0-0.1,0-0.2,0-0.3c0-1.4-0.9-1.9-1.9-2.4l-1.6-0.7 c-1.4-0.4-2.3-1.7-2.3-3.2c0-1.8,1.4-3.2,3.1-3.3c0.1,0,0.2,0,0.3,0c1.8-0.1,3.4,1.3,3.5,3.1c0,0.1,0,0.3,0,0.4v0.2L95.9,24.8z"
  }), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M108.6,21.2V30c0,2.5-1.5,4-3.7,4s-3.7-1.6-3.7-4v-8.8h1.3V30c0,1.5,0.8,2.7,2.3,2.7c1.3,0,2.4-1.1,2.4-2.4 c0-0.1,0-0.2,0-0.3v-8.8H108.6z"
  }), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M119,33.9l-2-5c-0.2,0-0.3,0-0.5,0h-2.1v5h-1.3V21.2h3.5c2.1,0,3.8,1.8,3.8,3.9c0,1.4-0.8,2.8-2.1,3.4l2.1,5.4 H119z M114.4,22.5v5.1h2.1c1.3,0.1,2.5-0.9,2.6-2.3c0-0.1,0-0.2,0-0.3c0.1-1.3-0.9-2.4-2.2-2.5c-0.1,0-0.2,0-0.3,0L114.4,22.5z"
  }), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M123.5,33.9l3.6-12.7h1.3l3.7,12.7h-1.4l-0.8-2.9h-4.3l-0.8,2.9H123.5z M126,29.7h3.6l-1.9-6.5L126,29.7z"
  }), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M142.7,33.9h-1.1l-4.9-9.7v9.8h-1.2V21.2h1.2l4.9,9.6v-9.6h1.2V33.9z"
  }), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M154.4,29.8v0.4c0.2,1.9-1.3,3.6-3.2,3.8c-0.2,0-0.3,0-0.5,0c-2.2,0-3.7-1.6-3.7-4v-5c0-2.5,1.5-4,3.7-4 c1.9-0.1,3.6,1.4,3.7,3.3c0,0.2,0,0.3,0,0.5v0.2h-1.3v-0.3c0.1-1.3-0.8-2.4-2.1-2.5c-0.1,0-0.2,0-0.3,0c-1.3,0-2.4,1.1-2.4,2.4 c0,0.1,0,0.2,0,0.3v5c-0.2,1.3,0.8,2.5,2.1,2.7c0.1,0,0.2,0,0.3,0c1.3,0.1,2.3-0.9,2.4-2.1c0-0.1,0-0.2,0-0.3v-0.5L154.4,29.8z"
  }), /*#__PURE__*/React.createElement(WordMarkPath, {
    invert: invert,
    d: "M159.8,28v4.5h5.3v1.3h-6.6V21.2h6.5v1.3h-5.2v4.2h4.8V28L159.8,28z"
  }), /*#__PURE__*/React.createElement(DividingLine, {
    invert: invert,
    x1: "60.3",
    y1: "0",
    x2: "60.3",
    y2: "34.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(uniqueId1, ")"),
    d: "M12.8,33.9h34.5L19.7,6.1C16,2.4,11,0.3,5.8,0.2H0l0.4,1.1l1.9,5L12.8,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2.4,6.4c3.8,6.5,13.7,7.1,14.8,17.2c0,0.4,0.4,0.8,0.8,0.8c5.9,0.9,11.4,3.4,16.1,7.1l0,0c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c0.1-0.1,0.1-0.2,0-0.2c-3.4-3.6-7.5-6.4-12-8.2l-1.4-0.6c-0.7-0.3-1.2-1-1.2-1.8c0.1-3,7.2-2.4,7.9-3.8l0.1-0.2 c-1.5-1.3-3.2-2.2-5.1-2.7c0,0.4,0.1,0.8,0.3,1.1c0.4,0.7-0.5,1.8-1.8,0.6L21,15.4C11.4,6.6,4.2,11.2,0.4,1.3L2.4,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(uniqueId2, ")"),
    d: "M25.4,16.4c-1,0-2-0.6-2.5-1.5c0.2,0.4,0.1,0.8-0.3,1C22.5,16,22.3,16,22.2,16v2.4c1-0.3,2.2-0.5,3.2-0.7V16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(uniqueId3, ")"),
    d: "M19.1,24.6c5.5,1.1,10.6,3.4,14.9,6.9C24,22.9,19.4,24.4,19.1,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(uniqueId4, ")"),
    d: "M4.4,6.8L4.4,6.8C2.5,5.4,1.2,3.5,0.4,1.3l1.9,5c3.8,6.5,13.7,7.1,14.8,17.2C16,10.7,10.4,12.6,4.4,6.8z"
  }));
};

QantasLogo.displayName = "QantasLogo";
QantasLogo.defaultProps = {
  invert: false,
  size: "small"
};
export default QantasLogo;